import { render, staticRenderFns } from "./stockist-table.vue?vue&type=template&id=932d465e&scoped=true&"
import script from "./stockist-table.vue?vue&type=script&lang=js&"
export * from "./stockist-table.vue?vue&type=script&lang=js&"
import style0 from "./stockist-table.vue?vue&type=style&index=0&id=932d465e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "932d465e",
  null
  
)

export default component.exports